<template>
  <div>
    <table
      class="table is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium is-marginless has-cells-vcentered"
      v-if="agenceAccess && agenceAccess.length">
      <thead>
        <tr class="is-size-6">
          <th></th>
          <th>
            Agence
          </th>
          <th></th>
          <th
            style="min-width: 50px; max-width: 50px"></th>
        </tr>
      </thead>
      <tbody class="is-size-6">
        <tr
          v-for="(m, i) in agenceAccess"
          :key="i">
          <td>
            <avatar
              :use-picto-custom="'fas fa-city'"
              :is-avatar="false"
              :use-picto="'fas fa-city'"
              class="has-background-grey-light is-medium has-text-white">
            </avatar>
          </td>
          <td>{{ m.agence.name }}</td>
          <td class="is-narrow">
            <span
              v-if="m.lots"
              class="tag is-allotement is-uppercase">
              {{ m.lots.length }} {{ 'Lot' | pluralize(m.lots.length > 1) }} {{ 'Alloté' | pluralize(m.lots.length > 1) }}
            </span>
          </td>
          <td
            class="is-paddingless is-marginless"
            style="width: 50px; min-width: 50px; max-width: 50px">
            <div class="field has-addons is-border-left">
              <div
                class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger">
                  <button
                    class="button is-square is-medium is-radiusless is-borderless"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu">
                    <i class="fal fa-ellipsis-v"></i>
                  </button>
                </div>
                <div
                  class="dropdown-menu"
                  role="menu">
                  <div class="dropdown-content has-text-left">
                    <a
                      class="dropdown-item">
                      <span class="icon is-size-5"><i class="fas fa-eye"></i></span>
                      <span
                        class="is-margin-left-xsmall"
                        @click="redirectChannel(m.agence.pk)">Voir l'agence</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="is-padding"
      v-else>
      Aucun mandat à afficher
    </div>
    <pagination
      class="has-background-transparent"
      :loading="false"
      :current-page="currentAgencePage"
      :total-page="currentAgenceTotalPage"
      @changePage="loadItems($event)" />
  </div>
</template>

<script>
import { Error } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'MandatLightList',
  mixins: [Error],
  props: {
    allotments: {
      type: Array
    },
    accesses: {
      type: Array,
      require: true
    },
    accessesCount: {
      type: Number
    },
    currentAgencePage: {
      type: Number
    },
    currentAgenceTotalPage: {
      type: Number
    },
    program: Object,
    lots: Array,
    mandats: {
      type: Array
    },
    agenceAccess: {
      type: Array
    }
  },
  data () {
    return {
      loading: false,
      selectedAccess: null
    }
  },
  computed: {
    ...mapGetters(['isPromoteur'])
  },
  methods: {
    loadItems (page) {
      this.$emit('loadAccessPage', page)
    },
    redirectChannel (id) {
      this.$router.push({ name: 'AgenceVue', params: { id } })
    },
    filteredAllotments (m) {
      return this.allotments.filter(x => m.pk.includes(x.mandat))
    }
  }
}
</script>
